import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getEncuestas, setFormulario } from "../actions";

//import Button from "react-bootstrap/Button";
//import Form from "react-bootstrap/Form";

const FormIniciativaFiltro = (props) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    nombre: props.inicio.nombre,
    codigo: props.inicio.codigo,
    estado: props.inicio.estado,
  });

  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    //console.log("values", values);

    const _params = {
      Token: "c3649ba4e3a81815",
      Function: "GetCmdicEncuestaLista",
      Parameters: {
        identificador: "0",
        id_equipo: 11,
      },
    };
    dispatch(getEncuestas(_params));
    dispatch(setFormulario({ campo: "filtroIniciativa", valor: values }));
  };
  //console.log("componente", props);

  return (
    <div>
      <form className="" onSubmit={handleSubmit}>
        {/* Uncomment the next line to show the success message */}
        {/* <div class="success-message">Success! Thank you for registering</div> */}
        <div className="row g-1">
          <div className="col-4">
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Código
                </label>
              </div>

              <div className="col-8">
                <input
                  id="codigo"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="codigo"
                  name="codigo"
                  value={values.codigo}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Factura
                </label>
              </div>

              <div className="col-8">
                <input
                  id="factura"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="factura"
                  name="factura"
                  value={values.factura}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  N° Pedido
                </label>
              </div>

              <div className="col-8">
                <input
                  id="numpedido"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="numpedido"
                  name="numpedido"
                  value={values.numpedido}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Estado
                </label>
              </div>

              <div className="col-8">
                <input
                  id="estado"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="estado"
                  name="estado"
                  value={values.estado}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
          </div>
          <div className="col">
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Fecha Inicio
                </label>
              </div>

              <div className="col-8">
                <input
                  id="fechaini"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechaini"
                  value={values.fechaini}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Fecha Término
                </label>
              </div>

              <div className="col-8">
                <input
                  id="fechatermino"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechatermino"
                  value={values.fechatermino}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Sucursal
                </label>
              </div>

              <div className="col-8">
                <input
                  id="sucursal"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="sucursal"
                  name="sucursal"
                  value={values.sucursal}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Vendedor
                </label>
              </div>

              <div className="col-8">
                <input
                  id="vendedor"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="vendedor"
                  name="vendedor"
                  value={values.vendedor}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
          </div>
          <div className="col">
            <p className="text-secondary fs-6">Estado de Solicitud</p>
            <div class="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
              ></input>
              <label className="form-check-label" for="flexCheckDefault">
                Esperando Revisión
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Esperando Inscripción
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Esperando Pago
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Pagado
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Observada
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Anulada
              </label>
            </div>
          </div>
          <div className="col">
            <div className="row">
              <div className="d-grid gap-2 col-8 mx-auto">
                <button className="btn btn-primary" type="button">
                  Filtrar {"     "}
                </button>
                <button className="btn btn-secondary btn-sm" type="button">
                  Limpiar filtros {"     "}
                </button>
              </div>
            </div>
            <br />
            <br />

            <div className="row">
              <p className="text-danger">
                Subir Archivo EXCEL para carga automatizada
              </p>
            </div>
            <div className="mb-3">
              <label
                for="formFileSm"
                className="form-label text-danger"
              ></label>
              <input
                className="form-control form-control-sm"
                id="formFileSm"
                type="file"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormIniciativaFiltro;
